import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import AdminApp from "./AdminApp";
import CodexApp from "./CodexApp";
import { isNative } from "./native";

const _path = window.location.pathname;
const _host = (window.location.hostname || "").toLowerCase();
// 별도 도메인 codex.to-be.kr(또는 codex.* 서브도메인)으로 접속하면 루트에서 바로 Codex 작업실.
const isCodexHost = _host === "codex.to-be.kr" || _host.split(".")[0] === "codex";
const isAdminPath = _path === "/admin" || _path.startsWith("/admin/");
const isCodexPath = isCodexHost || _path === "/codex" || _path.startsWith("/codex/");
const RootApp = isCodexPath ? CodexApp : isAdminPath ? AdminApp : App;

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RootApp />
  </React.StrictMode>
);

// 서비스워커는 웹/PWA 에서만 등록한다.
// ★네이티브 앱(Capacitor)에서 서비스워커가 첫 화면 요청을 가로채면 Capacitor 로컬 프록시를
//   건너뛰어 플러그인이 주입되지 않는다 → 파일 저장·공유·푸시가 통째로 죽는다(2026-09-08·09 실측).
//   그래서 네이티브에서는 등록하지 않고, 옛 버전이 남긴 서비스워커가 있으면 해제한다
//   (해제는 다음 실행부터 깨끗해진다 — "앱을 껐다 켜 주세요" 안내와 한 묶음).
if ("serviceWorker" in navigator) {
  if (isNative()) {
    navigator.serviceWorker.getRegistrations()
      .then((rs) => rs.forEach((r) => { try { r.unregister(); } catch (e) {} }))
      .catch(() => {});
  } else if (process.env.NODE_ENV === "production") {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/service-worker.js").catch(() => {});
    });
  }
}
